import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=90a35e1a&scoped=true"
import script from "./widget.vue?vue&type=script&lang=js"
export * from "./widget.vue?vue&type=script&lang=js"
import style0 from "./widget.vue?vue&type=style&index=0&id=90a35e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a35e1a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsOverlay: require('/home/ticketshoplv/public_html/ticketshop.lt/components/elements/Overlay.vue').default,ElementsLoader: require('/home/ticketshoplv/public_html/ticketshop.lt/components/elements/Loader.vue').default,HeaderLogo: require('/home/ticketshoplv/public_html/ticketshop.lt/components/Header/Logo.vue').default,HeaderLangSwitch: require('/home/ticketshoplv/public_html/ticketshop.lt/components/Header/LangSwitch.vue').default,Cart: require('/home/ticketshoplv/public_html/ticketshop.lt/components/Cart/Index.vue').default,CartMobile: require('/home/ticketshoplv/public_html/ticketshop.lt/components/Cart/Mobile.vue').default})
